import { instance } from '@/services/avik-api-gateway'
import { DeviationDisruptionReason } from '@/types/deviation-disruption-reason'
import { AxiosResponse } from 'axios'

export function updateDeviationDisruptionReason(
  body: DeviationDisruptionReason
): Promise<AxiosResponse<DeviationDisruptionReason>> {
  return instance.put(`/deviation-disruption-activity/${body.uuid}`, body)
}
